import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['link']
  static values = { baseUrl: String }

  connect() {
    this.updateLink()
  }

  updateLink() {
    const select = this.element.querySelector('select')
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set('label[product_item_id]', select.value)

    this.linkTarget.href = url.toString()
  }
}
